import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { compose } from 'redux'
import Modal from 'react-modal'
import { get } from 'lodash'

import IconExit from '../components/icons/IconExit'
import { getCurrentStand } from '../../selectors/menus'

const MenuWithConfirmationModal = ({ standName, history, redirectTo }) => {
  const [isModalOpen, setModalOpen] = useState(false)

  const toggleModal = () => {
    setModalOpen(!isModalOpen)
  }

  const handleConfirm = () => {
    toggleModal()
    history.push(redirectTo)
  }

  return (
    <>
      <button
        type='button'
        className='menu__exit'
        onClick={toggleModal}
      >
        <IconExit className='menu__icon' />
        Exit
      </button>
      <div className='menu__top'>
        <div className='menu__brand'>{standName}</div>
      </div>
      <Modal className='modal' overlayClassName='overlay' isOpen={isModalOpen}>
        <div className='modal__copy'>
          This will remove the items in your cart.
        </div>
        <div className="modal__actions">
          <button className='btn -outline' type='button' onClick={toggleModal}>Cancel</button>
          <button className='btn -primary' type='button' onClick={handleConfirm}>Proceed</button>
        </div>
      </Modal>
    </>
  )
}

MenuWithConfirmationModal.defaultProps = {
  redirectTo: '/kiosk/menu_select',
}

MenuWithConfirmationModal.propTypes = {
  standName: PropTypes.string.isRequired,
  redirectTo: PropTypes.string,
}

const mapStateToProps = state => ({
  standName: get(getCurrentStand(state), 'name'),
})

export default compose(
  withRouter,
  connect(mapStateToProps),
)(MenuWithConfirmationModal)
